import LogRocket from 'logrocket';

window.LogRocket = LogRocket;
